export function isFreeTextSearchQueryKey(key) {
  return key === 'text' || key === 'textOperator';
}

export function getFreeTextSearchValue(searchProps) {
  return typeof searchProps?.text === 'string' ? searchProps.text : '';
}

export function assignQueryKeyToSearchFilters(result, key, value) {
  if (isFreeTextSearchQueryKey(key)) {
    return;
  }
  if (key.endsWith('Operator')) {
    const id = key.replace(/Operator/ig, '');
    if (result[id]) {
      result[id].operator = value;
    } else {
      result[id] = { operator: value };
    }
    return;
  }
  if (key === 'params2') {
    result.params2 = value;
    return;
  }
  if (result[key]) {
    result[key].value = value;
    return;
  }
  result[key] = { value };
}

export function createSearchFiltersFromQuery(searchProps = {}) {
  const result = { text: getFreeTextSearchValue(searchProps) };
  Object.entries(searchProps).forEach(([key, value]) => {
    assignQueryKeyToSearchFilters(result, key, value);
  });
  return result;
}
